// TelcoTrack — park an export (or filter) cluster on the page-header subtitle row.

import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { PageHeaderTableToolsService } from '../../core/services/page-header-table-tools.service';

@Directive({
  selector: '[ttPageHeaderTableTools]',
})
export class PageHeaderTableToolsDirective implements AfterViewInit, OnDestroy {
  constructor(
    private readonly host: ElementRef<HTMLElement>,
    private readonly tableTools: PageHeaderTableToolsService,
  ) {}

  ngAfterViewInit(): void {
    this.tableTools.attach(this.host.nativeElement);
  }

  ngOnDestroy(): void {
    this.tableTools.detach(this.host.nativeElement);
  }
}
